import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const EmailPopoverButton = () => {
  const [showPopover, setShowPopover] = useState(false);
  const popoverRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowPopover(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const emailProviders = [
    {
      name: 'Gmail',
      url: 'https://mail.google.com/mail/?view=cm&fs=1&to=info@pelicanrx.com&su=Subscription%20Renewal&body=Please%20renew%20my%20subscription.',
      icon: '📧',
      color: '#4285F4'
    },
  ];

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setShowPopover(!showPopover)}
        style={{
          border: '1px solid #e5e7eb',
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '12px 20px',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontWeight: '500',
          fontSize: '14px'
        }}
      >
        📧 Email Us <span style={{ marginLeft: '4px' }}>▼</span>
      </button>

      {showPopover && (
  <div
    ref={popoverRef}
    style={{
      position: 'absolute',
      top: 'calc(100% + 8px)',
      left: '0',
      backgroundColor: 'white',
      border: '1px solid #e5e7eb',
      borderRadius: '8px',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
      minWidth: '250px',
      zIndex: 1060, // make sure it stays on top
      overflowY: 'auto',
      maxHeight: '250px', // scroll if too long
      scrollbarWidth: 'thin',
      scrollbarColor: '#ccc transparent',
    }}
  >
    <div
      style={{
        padding: '12px 16px',
        backgroundColor: '#f8f9fa',
        fontWeight: '600',
        fontSize: '14px',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky',
        top: 0,
        zIndex: 1,
      }}
    >
      Choose Email Provider
    </div>
    <div style={{ padding: '8px' }}>
      {emailProviders.map((provider, index) => (
        <a
          key={index}
          href={provider.url}
          target={provider.name !== 'Default Mail' ? '_blank' : undefined}
          rel={provider.name !== 'Default Mail' ? 'noopener noreferrer' : undefined}
          onClick={() => setShowPopover(false)}
          style={{
            textDecoration: 'none',
            color: '#333',
            padding: '10px 12px',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            transition: 'all 0.2s ease',
            border: '1px solid #e5e7eb',
            marginBottom: index < emailProviders.length - 1 ? '8px' : '0',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#f8f9fa';
            e.currentTarget.style.borderColor = provider.color;
            e.currentTarget.style.transform = 'translateX(4px)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
            e.currentTarget.style.borderColor = '#e5e7eb';
            e.currentTarget.style.transform = 'translateX(0)';
          }}
        >
          <span style={{ fontSize: '20px' }}>{provider.icon}</span>
          <span style={{ fontWeight: '500', fontSize: '14px', flex: 1 }}>
            {provider.name}
          </span>
        </a>
      ))}
    </div>
  </div>
)}

    </div>
  );
};

const SubscriptionExpiredModal = ({ show, message, onClose }) => {
  return (
    <>
      <style>{`
        .subscription-expired-modal .modal-content {
          border: none;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        }
        
        .subscription-expired-modal .modal-header {
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
          border: none;
          padding: 2rem;
          position: relative;
        }
        
        .subscription-expired-modal .modal-header::before {
          content: '⚠️';
          position: absolute;
          top: 15px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 30px;
          background: white;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
          animation: bounce 2s ease-in-out infinite;
        }
        
        @keyframes bounce {
          0%, 100% { transform: translateX(-50%) translateY(0); }
          50% { transform: translateX(-50%) translateY(-5px); }
        }
        
        .subscription-expired-modal .modal-title {
          color: white !important;
          font-weight: 700 !important;
          text-align: center;
          width: 100%;
          font-size: 1.5rem;
          margin-top: 3rem;
        }
        
        .subscription-expired-modal .btn-close {
          filter: brightness(0) invert(1);
          opacity: 0.8;
        }
        
        .subscription-expired-modal .btn-close:hover {
          opacity: 1;
        }
        
        .subscription-expired-modal .modal-body {
          padding: 2.5rem 2rem;
          background: #ffffff;
        }
        
        .message-text {
          color: #4b5563;
          font-size: 1rem;
          line-height: 1.6;
          margin-bottom: 1.5rem;
          text-align: center;
        }
        
        .contact-section {
          background: linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%);
          border-radius: 12px;
          padding: 1.5rem;
          margin-top: 1rem;
          text-align: center;
        }
        
        .contact-title {
          color: #374151;
          font-weight: 600;
          font-size: 0.95rem;
          margin-bottom: 1rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .subscription-expired-modal .modal-footer {
          border: none;
          padding: 1.5rem 2rem 2rem;
          background: white;
        }
        
        .close-btn {
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%) !important;
          border: none !important;
          border-radius: 12px !important;
          padding: 14px !important;
          font-weight: 600 !important;
          font-size: 1rem !important;
          width: 100% !important;
          box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3) !important;
          transition: all 0.3s ease !important;
        }
        
        .close-btn:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 8px 20px rgba(255, 107, 107, 0.4) !important;
          background: linear-gradient(135deg, #ff5555 0%, #e04e60 100%) !important;
        }
         
      `}</style>

      <Modal
        show={show}
        onHide={onClose}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="subscription-expired-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Subscription Expired</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="message-text">
            {message || 'Your subscription has expired. Please renew to continue enjoying our services.'}
          </p>

          <div className="contact-section">
            <div className="contact-title">Contact Support to Renew</div>
            <EmailPopoverButton />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={onClose} className="close-btn">
            Got It
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SubscriptionExpiredModal;
